/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Table,
  TableBody,
  Box,
  Typography,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import {
  InfoOutlined,
  NotificationsActive,
} from '@mui/icons-material';

import LoadingTagReminder from '../../pages/settings/TaskPage/reminders/components/LoadingTagReminder';
import TagReminder from '../../pages/settings/TaskPage/reminders/components/TagReminder';
import styles from './styles';
import { getTagRemindersForTag } from '../../redux/tagReminder/actions';
import { grey } from '../../utils/brandColors';

const HorseDueDatesComponent = ({
  classes,
  barnHorse,
  isAdmin,
  health,
  zIndex,
}) => {
  const dispatch = useDispatch();

  const selectedBarn = useSelector((state) => state.barn.selectedBarn)
  const isFetchingTagTagReminders = useSelector((state) => state.tagReminder.isFetchingTagTagReminders);
  const tagTagReminders = useSelector((state) => state.tagReminder.tagTagReminders);

  const loadData = () => {
    dispatch(getTagRemindersForTag(parseInt(barnHorse.pingumTagId, 10)))
  }

  React.useEffect(() => {
    if (barnHorse && barnHorse.pingumTagId) {
      loadData()
    }
  }, [barnHorse]);

  const reminders = tagTagReminders
    .filter((tr) => !health || tr.eventTemplateReminder.eventTemplate.tags.find((t) => t.tagType.id === selectedBarn.barnMetadata.healthTagTypeId))

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <NotificationsActive color="primary" />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              ml: 1,
            }}
          >
            {!health
              ? 'Reminders'
              : 'Health Reminders'}
          </Typography>
        </Box>
      </Box>
      <Table size="small" className={classes.table}>
        <TableBody>
          {
            !!(isFetchingTagTagReminders) && [1, 2, 3, 4, 5].map((item) => (
              <LoadingTagReminder key={`loading-item-${item}`} classes={classes} includeHorse={false} />
            ))
          }
          {
            (!isFetchingTagTagReminders) && (
              reminders.sort((a, b) => -b.tag.name.localeCompare(a.tag.name)).map((tr) => (
                <TagReminder
                  key={`task-item-${tr.id}`}
                  tagReminder={tr}
                  fullScreen={false}
                  includeHorse={false}
                  includeTask
                  condensed
                  triggerDataRefresh={() => { loadData() }}
                  zIndex={zIndex}
                />

              ))
            )
          }
        </TableBody>
      </Table>
      {
        !isFetchingTagTagReminders && tagTagReminders.length === 0 && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <InfoOutlined
              sx={{
                fontSize: '3.5rem',
                color: grey[400],
                m: 2,
              }}
            />
            <Typography sx={{ fontWeight: 300 }}>
              No reminders setup for this horse
            </Typography>
          </Box>
        )
      }

      {
        isAdmin && (
          <Typography
            align="center"
            component="div"
            sx={{
              fontWeight: 300,
              p: 1,
              backgroundColor: grey[50],
              textWrap: 'wrap',
            }}
          >
            Manage which tasks to receive reminders for from the <a href="/settings/tasks/reminders">reminder settings page</a>
          </Typography>
        )
      }
    </Box>
  );
}

HorseDueDatesComponent.propTypes = {
  classes: PropTypes.object,
  barnHorse: PropTypes.object,
  isAdmin: PropTypes.bool,
  health: PropTypes.bool,
  zIndex: PropTypes.number,
};
HorseDueDatesComponent.defaultProps = {
  classes: {},
  barnHorse: null,
  isAdmin: false,
  health: false,
  zIndex: undefined,
};

export default withStyles(styles)(HorseDueDatesComponent);
